import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'
import styled from 'styled-components'

import type { components } from '../../../constants/schema'

import { requestIdentityVerification, convertIdentityVerificationResult } from '../../../utils/identityVerification'
import { handleIdentify } from '../../../utils/handleIdentify'

import { StoresContext } from '../../../provider/StoreProvider'

import { useIsMobile } from '../../../hooks/useIsMobile'
import { useUserInfo } from '../../../hooks/useUserInfo'

import { Head } from '../../../components/head/Head'
import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Button } from '../../../components/button'
import { Text } from '../../../components/text'
import { Footer } from '../../../components/footer'
import { Header } from '../../../components/header'

import { Color } from '../../../theme/color'

const HEAD_INFO = {
  title: '휴대폰 번호 변경 | 미술품 조각투자 플랫폼, 아티피오',
  ogTitle: '휴대폰 번호 변경 | 미술품 조각투자 플랫폼, 아티피오',
  ogUrl: window.location.href,
}

export function PhoneVerification() {
  const {
    commonStore: { setShowTab, setInvalidAccess },
  } = useContext(StoresContext)

  const location = useLocation()
  const isMobile = useIsMobile()
  const { data: userInfo, isLogin, isCheckingLogin } = useUserInfo()

  const phoneNumber = userInfo?.identification?.danalPhoneNumber

  useEffect(() => {
    setShowTab(false)
  }, [])

  useEffect(() => {
    if (!isLogin && !isCheckingLogin) setInvalidAccess(true)
  }, [isLogin, isCheckingLogin])

  useEffect(() => {
    if (localStorage.getItem('isVerification') !== 'true') return

    if (location.search.includes('identityVerificationId')) {
      const convertQuery = convertIdentityVerificationResult(location.search.substring(1))
      handleIdentify(convertQuery, '/personalInfo')
    }
  }, [location])

  const requestVerification = async () => {
    const response = await requestIdentityVerification(`${window.location.origin}/personalInfo/phone`)
    console.log({ response, isMobile, location, userInfo })

    if (!isMobile && response && response.code !== 'FAILURE_TYPE_PG') {
      handleIdentify(response as components['schemas']['ReqQueryIdentification'], '/personalInfo')
      return
    }
  }

  return (
    <>
      <Head {...HEAD_INFO} />
      <Wrap>
        <Header type="SUB" title="휴대폰 번호" href={location.search ? '/personalInfo' : undefined} />
        <Content>
          <Container>
            <Text size={24} weight={600} lineHeight={34}>
              이동통신사 본인인증을 통해
              <br />
              휴대폰 번호를 등록 또는 변경하실 수 있어요.
            </Text>
            <InputBox onClick={requestVerification}>
              {phoneNumber
                ? `${userInfo?.identification?.danalPhoneNumber?.substring(
                    0,
                    3,
                  )}****${userInfo?.identification?.danalPhoneNumber?.substring(7, 11)}`
                : '휴대폰 번호를 등록해 주세요.'}
            </InputBox>
          </Container>
        </Content>
        <Footer>
          <Button type="primary" size="large" block={true} onClick={requestVerification}>
            {phoneNumber ? '변경하기' : '등록하기'}
          </Button>
        </Footer>
      </Wrap>
    </>
  )
}

const Container = styled.div`
  padding: 56px 24px 24px;
  ion-item {
    overflow: hidden;
    border: 1px solid #ebebeb;
    border-radius: 8px;
  }
`

const InputBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  margin-top: 34px;
  padding: 16px;
  border: 1px solid ${Color.gray_3};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${Color.gray_4};
`
